/**
 * Soft "cloud-edged" SVG divider between sections.
 * Variants: 'top' (cloud bumps up) | 'bottom' (cloud bumps down)
 * `color` is the section background color (so the divider blends).
 */
export const CloudDivider = ({ position = "top", color = "#fffaec", flip = false }) => {
  const transform = position === "top"
    ? (flip ? "rotate(180deg) scaleX(-1)" : "rotate(180deg)")
    : (flip ? "scaleX(-1)" : "none");

  return (
    <div
      aria-hidden="true"
      className="absolute left-0 right-0 pointer-events-none"
      style={{
        [position]: 0,
        height: 80,
        transform,
        transformOrigin: "center",
        zIndex: 1,
      }}
    >
      <svg
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
        className="w-full h-full"
      >
        <path
          d="M0,80 L0,40 C90,10 180,5 280,25 C380,45 460,15 580,20 C700,25 780,55 900,45 C1020,35 1100,5 1220,15 C1320,23 1380,45 1440,35 L1440,80 Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default CloudDivider;
